import React, { useContext } from 'react';
import { useMonth } from '@datepicker-react/hooks';
import { ChevronLeftOutline, ChevronRightOutline } from '@olist/design-system-icons';
import format from './../../external/date-fns/esm/format/index.js';
import DatepickerContext from './context.js';
import Day from './Day.js';
import { MonthHeaderStyle, MonthNavStyle, WeekdaysGridStyle, WeekdayContainerStyle, DaysGridStyle } from './styles.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

function Month({ year, month, firstDayOfWeek, goToNextMonths, goToPreviousMonths, }) {
    const { locale } = useContext(DatepickerContext);
    const { days, weekdayLabels, monthLabel } = useMonth({
        year,
        month,
        firstDayOfWeek,
        dayLabelFormat: (date) => format(date, 'dd', { locale }),
        monthLabelFormat: (date) => format(date, 'MMMM yyyy', { locale }),
        weekdayLabelFormat: (date) => format(date, 'eee', { locale }),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(MonthHeaderStyle, { justifyContent: "space-between" },
            React.createElement(MonthNavStyle, { type: "button", onClick: goToPreviousMonths },
                React.createElement(ChevronLeftOutline, null)),
            React.createElement(Caption, { textTransform: "capitalize" }, monthLabel),
            React.createElement(MonthNavStyle, { type: "button", onClick: goToNextMonths },
                React.createElement(ChevronRightOutline, null))),
        React.createElement(WeekdaysGridStyle, null, weekdayLabels.map((dayLabel) => {
            const dayLabelFirstLetter = dayLabel[0].toLocaleUpperCase();
            return (React.createElement(WeekdayContainerStyle, { key: dayLabel }, dayLabelFirstLetter));
        })),
        React.createElement(DaysGridStyle, null, days.map((day, index) => {
            if (typeof day === 'object') {
                return (React.createElement(Day, { date: day.date, key: day.date.toString(), dayLabel: day.dayLabel }));
            }
            return React.createElement("div", { key: index });
        }))));
}

export { Month as default };
